import { gql } from '@apollo/client'

export default gql`
  query GetBattleDemoPvPSeasons($isGuild: Boolean!) {
    getPvpSeasonSchedules(forGuild: $isGuild) {
      isActive
      metaKey
      season
      seasonalReward {
        fromRank
        toRank
        rewards {
          metaKey
          qty
        }
      }
    }
  }
`
